import type { ComponentType, PropsWithChildren, ReactElement } from 'react';

import type { GenericHtmlProps } from '../../types/common';
import TooltipTrigger from '../tooltip_trigger/tooltip_trigger';
import type { TooltipPlacement } from '../tooltip_trigger/utils';
import { shouldShowTooltip } from './should_show_tooltip';

// It has very similar props as TooltipTrigger component
// but uses only a subset of them
type Props<P> = PropsWithChildren<{
  component?: ComponentType<P> | string;
  componentProps?: P;
  tooltipText?: string;
  tooltipClass?: string;
  tooltipPlacement?: TooltipPlacement;
}>;

const Ellipsis = <P = GenericHtmlProps>({
  children,
  component = 'div',
  componentProps = {} as P,
  tooltipClass,
  tooltipPlacement,
  tooltipText,
}: Props<P>): ReactElement => (
  <TooltipTrigger<P>
    tooltipText={tooltipText || children}
    tooltipClass={tooltipClass}
    shouldShowTooltip={shouldShowTooltip}
    placement={tooltipPlacement}
    component={component}
    componentProps={componentProps}
  >
    {children}
  </TooltipTrigger>
);

export default Ellipsis;
